import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import MaterialTable from 'material-table'
import { tableIcons } from '../../../class/utils'

import { Label, PrimaryButton } from '../../default'
import { CustomerProductTableModal } from '../../modal'

function TableFinancial({ classes, customers }) {
  const { t } = useTranslation()
  const [enableModal, setEnableModal] = useState(false)
  const [currentCustomer, setCurrentCustomer] = useState(null)


  const _getButtonStyle = () => {
    return {
      fontWeight: 'bold'
    };
  }

  const openFinancialModal = (customer) => {
    setCurrentCustomer({
      id: customer.customer_id,
      fullName: customer.full_name,
      email: customer.email,
      product_table_id: customer.product_table_id
    })
    setEnableModal(true)
  }

  const prepareColumns = () => {
    return [
      { title: t('panels.block.table.columns.id'), field: 'customer_id' },
      { title: t('panels.block.table.columns.full_name'), field: 'full_name' },
      { title: t('panels.block.table.columns.email'), field: 'email' },
      { title: t('panels.block.table.columns.phone'), field: 'phone' },
      { title: t('panels.block.table.columns.last_login'), field: 'last_login' },
      { title: t('panels.block.table.columns.cnpj'), field: 'cnpj' },
      {
        title: t('panels.financial.table.columns.action'),
        field: 'action',
        render: rowData => (
          <PrimaryButton onClick={() => openFinancialModal(rowData)} style={_getButtonStyle()}>
            {t('panels.productSearch.table.action')}
          </PrimaryButton>
        )
      }
    ]
  }

  const prepareData = () => {
    if (!customers) {
      return [];
    }

    return customers.map(customer => {
      return {
        customer_id: customer.customer_id,
        full_name: `${customer.first_name} ${customer.last_name}`,
        email: customer.customerContact ? customer.customerContact.email : "Indefinido",
        phone: customer.customerContact ? customer.customerContact.phone_1 : "Indefinido",
        last_login: customer.last_login ? customer.last_login.split("T").join(" ").split(".").slice(0, 1).join(" ") : "Indefinido",
        cnpj: customer.customerCompany ? customer.customerCompany.cnpj : "Indefinido",
        product_table_id: customer.product_table_id
      }
    });
  }

  const onRefresh = () => {
    setEnableModal(false);
    setCurrentCustomer(null);
  }

  return (
    <>
      <CustomerProductTableModal
        onRefresh={onRefresh}
        onClose={() => setEnableModal(false)}
        open={enableModal}
        currentCustomer={currentCustomer} />
      <MaterialTable
        icons={tableIcons}
        data={prepareData()}
        columns={prepareColumns()}
        options={{
          search: false,
          headerStyle: {
            fontWeight: 'bold'
          }
        }}
        localization={t('materialTableLocale', { returnObjects: true })}
        components={{
          Toolbar: () => (
            <div style={{ padding: '16px' }}>
              <Label v='h6' bold>{t('panels.block.table.title')}</Label>
            </div>
          )
        }}
      />
    </>
  )
}

TableFinancial.propTypes = {
  customers: PropTypes.array,
}

TableFinancial.defaultProps = {
  customers: []
}

const styles = theme => ({

})

export default withStyles(styles)(TableFinancial)